import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=ef163446"
import script from "./UploadImg.vue?vue&type=script&lang=ts"
export * from "./UploadImg.vue?vue&type=script&lang=ts"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=ef163446&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports